import GoogleLogo from '@resources/logos/integrations/Google/google_logo.png';
import AuthLoginButton from './AuthLoginButton';

export default function GoogleLoginButton({ to, buttonText }: { to: string; buttonText: string }) {
  return <AuthLoginButton to={to} logoSrc={GoogleLogo} altText='Google logo' buttonText={buttonText} />;
}
